// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__CHY4d","footer":"ModalUpdate_footer__OxuXF"};